import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing, table_borderRadius } from 'ext-ui/style/spacing'
import { font_xs } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const staticPillClassName = 'BulkInviteReviewTable-staticPill'

// Clip the DataGrid to the Box's rounded corners so the grid's square edges
// don't bleed past the outlined border. Scoped here (not on the shared Box)
// because global clipping would cut off absolutely-positioned popovers in
// other outlineBorder Box consumers.
export const gridClip = css`
  overflow: hidden;
  border-radius: ${table_borderRadius};

  .${staticPillClassName} {
    pointer-events: none;
  }

  /* Rows aren't selectable here, so suppress the shared DataGrid's row-hover
     highlight (it reads as a selection affordance). The grid drives every hover
     background off this custom property. */
  .MuiDataGrid-root {
    --hover-color: transparent;
  }
`

export const statusCell = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${spacing(1)};
  width: 100%;
`

export const statusWithTooltip = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(1)};
`

// Leading status icon + label inside a pill. The icon inherits the pill's text
// color via fill="currentColor".
export const pillContent = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(1)};

  svg {
    flex-shrink: 0;
  }
`

export const statusReason = css`
  ${font_xs}
  color: ${text_colorTextSecondary};
`

export const roleCell = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing(1)};
  width: 100%;
`

// Lets the dropdown fill the cell while the warning tooltip sits to its right.
export const roleDropdown = css`
  flex: 1;
  min-width: 0;
`

// Keeps the role warning in the accessibility tree (the tooltip only reveals it
// on hover) without adding visible clutter.
export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
